import { useState, useEffect } from "react"
import { useAuth } from "@clerk/clerk-react"
import { checkSuperAdmin } from "../app/api/super-admin-api"

export function useIsSuperAdmin() {
    const { getToken, isLoaded: authLoaded, userId, sessionId } = useAuth()
    const [isSuperAdmin, setIsSuperAdmin] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)
    const [checkedIdentity, setCheckedIdentity] = useState<string>()
    const identity = JSON.stringify([userId, sessionId])

    useEffect(() => {
        if (!authLoaded) return

        let cancelled = false
        setIsSuperAdmin(false)
        setIsLoaded(false)
        setCheckedIdentity(identity)

        const check = async () => {
            try {
                const token = await getToken()
                if (cancelled) return
                if (!token) {
                    setIsSuperAdmin(false)
                    setIsLoaded(true)
                    return
                }
                const result = await checkSuperAdmin(token)
                if (cancelled) return
                setIsSuperAdmin(result.isSuperAdmin)
            } catch {
                if (!cancelled) setIsSuperAdmin(false)
            } finally {
                if (!cancelled) setIsLoaded(true)
            }
        }

        check()
        return () => {
            cancelled = true
        }
    }, [authLoaded, getToken, identity])

    const current = authLoaded && checkedIdentity === identity
    return { isSuperAdmin: current && isSuperAdmin, isLoaded: current && isLoaded }
}
